import { baseApi } from './baseApi';

const BASE = 'products'

const productsApi = baseApi.injectEndpoints ({
  endpoints: builder => ({
    getProducts: builder.query ({
      query: collegeId => `${BASE}?school=${collegeId}&status=1`,
      transformResponse: res => res.data
    }),
    getProductsWithQuery: builder.query ({
      query: ({collegeId, ...query}) => ({
        url: BASE,
        params: {
          school: collegeId,
          status: 1,
          ...query
        }
      }),
      providesTags: ['products-query'],
      transformResponse: res => res.data
    }),
    getProduct: builder.query ({
      query: id => `${BASE}/${id}?status=1`,
      transformResponse: res => res.data,
    }),
    getProductWith: builder.query({
      query: ({id, ...params}) => ({
        url: `${BASE}/${id}?status=1`,
        params,
      }),
      providesTags: ['product-query'],
      transformResponse: res => res.data,
    }),
    getVariations: builder.query ({
      query: id => `${BASE}?parent=${id}&status=1`,
      transformResponse: res => res.data
    }),
    getVariationsWith: builder.query ({
      query: ({id, ...params}) => ({
        url:`${BASE}?parent=${id}&status=1`,
        params,
      }),
      providesTags: ['variations-query'],
      transformResponse: res => res.data
    }),
    addToWaitList: builder.mutation({
      query: (productId) => ({
        url: `${BASE}/add-to-wait-list/${productId}`,
        method: 'POST',
      }),
      invalidatesTags: ['WaitList', 'variations-query', 'products-query', 'product-query'],
    }),
    deleteFromWaitList: builder.mutation({
      query: (productId) => ({
        url: `${BASE}/delete-from-wait-list/${productId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['WaitList', 'variations-query', 'products-query', 'product-query'],
    }),
    getMyWaitList: builder.query({
      query: () => `${BASE}/get-my-wait-list`,
      providesTags: ['WaitList'],
      transformResponse: res => res.data,
    }),
    getRelatedProducts: builder.query({
      query: id => `${BASE}/${id}/related-products`,
      transformResponse: res => res.data,
    }),
  }),
});

export const {
  useGetProductQuery,
  useGetProductsQuery,
  useGetProductsWithQueryQuery,
  useGetProductWithQuery,
  useGetVariationsWithQuery,
  useGetVariationsQuery,
  useLazyGetVariationsQuery,
  useAddToWaitListMutation,
  useDeleteFromWaitListMutation,
  useGetMyWaitListQuery,
  useGetRelatedProductsQuery,
} = productsApi;
